import * as React from "react";

export default () => {
    return <div className="text-center"><LoaderSpan /></div>
}

const LoaderSpan = () => (<span className="k-icon k-i-loading"></span>);

export { LoaderSpan }